var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"inline","position":"relative"}},[_vm._v(" "+_vm._s(_vm.text)+" "),(_vm.show)?_c('img',{staticStyle:{"width":"30px","height":"14px"},attrs:{"src":require("@/assets/icons/new.png"),"alt":"","title":`最近更新：` + _vm.date}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }